module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "header",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "flexstart"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-contentname lbold font18"
  }, [_vm._v(_vm._s(_vm.contentName))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rslogo"
  }, [_c('img', {
    attrs: {
      "src": "static/images/icon/header/logo.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c5e5f876", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-c5e5f876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 729
// module chunks = 1